import axios, { client2, strapiClient } from "@/config/axios-wrapper";
import {
  SubscriptionFeaturesLeft,
  SubscriptionPlan,
  SubscriptionPlanTrialStatus,
} from "@/types/subscription";


export const getSubscriptionTrialStatus = async (organizationId: string) => {
  const response = await client2.get<{ result: SubscriptionPlanTrialStatus; success: boolean }>(
    `/organizations/${organizationId}/trialStatus`,
  );
  return response.data;
};

export const getSubscriptionFeaturesLeftDetails = async (organizationId: string) => {
  const response = await client2.get<{ result: SubscriptionFeaturesLeft; success: boolean }>(
    `/organizations/${organizationId}/featuresLeft`,
  );
  return response.data;
};

export const getSubscriptionDetails = async (organizationId: string) => {
  const response = await client2.get<{ result: SubscriptionPlan; success: boolean }>(
    `/organizations/${organizationId}/subscription`,
  );
  return response.data;
};

export const subscribeToNewsletter = async (data: { Email: string }) => {
  const response = await strapiClient.post(`/subscribers`, { data });
  return response.data;
};
